import * as React from 'react';


/**
 * React lint is persistent about this "use exhaustive deps" thing -- but they don't seem to realize an empty deps
 * array is standard for running an effect once when a component mounts.
 */
export const useMount = (onMount: React.EffectCallback): void => React.useEffect(onMount, []);
